import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchToursDetails } from "../../api/toursDetailsApi";
// import { fetchToursDetails } from "../../../lib/service/tours/api"; // Adjust the path as necessary

// Async thunk for fetching tour details
export const fetchToursDetailsThunk = createAsyncThunk(
  "toursDetails/fetchToursDetails",
  async ({ products_id }, { rejectWithValue }) => {
    try {
      const response = await fetchToursDetails({ products_id });
      return response.data; // Assuming the API response has a `data` property
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Initial state
const initialState = {
  details: null, // Tour details
  loading: false,
  error: null,
};

// Slice
const toursDetailsSlice = createSlice({
  name: "toursDetails",
  initialState,
  reducers: {
    clearDetails(state) {
      state.details = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchToursDetailsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchToursDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload;
      })
      .addCase(fetchToursDetailsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearDetails } = toursDetailsSlice.actions;
export default toursDetailsSlice.reducer;
